export class Compania {
  idCompania: number;
  nombreCompania: string;
  codigo: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/compania.ts